<template>
  <div class="homecontent">
    <div class="">
      <div class="content-title">全国风月信息大全</div>
      <div class="content-dec">
        防骗提示：上门的见人之前不要给钱！！不管她说任何理由，都是骗子！！推销办卡的千万别办卡！！办卡的都坑！！
        查阅会所前，建议先认真阅读《风月扫盲》
        <router-link to="/info">（直接点我进入风月扫盲）！！</router-link>
      </div>
    </div>
    <div class="content">
      <div class="content-table">
        <div id="tabBox" class="content-table-content">
          <div class="content-table-content-cell">
            <div class="td th content-table-td">
              省份
            </div>
            <div class="td th content-table-td-1">
              城市
            </div>
            <div class="td th">
              区县
            </div>
            <div class="td th">
              详细地址
            </div>
            <div class="td th">
              会所名称
            </div>
            <div class="td th">
              联系方式
            </div>
            <div class="td th">
              项目
            </div>
            <div class="td th">
              情况
            </div>
          </div>
          <div
            class="content-table-content-cell"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="td content-table-td">
              {{item.province}}
            </div>
            <div class="td content-table-td-1">
              {{item.city}}
            </div>
            <div class="td">
              {{item.region}}
            </div>
            <div class="td">
              {{item.area}}
            </div>
            <div class="td">
              {{item.name}}
            </div>
            <div class="td">
              {{item.tel}}
            </div>
            <div class="td">
              {{item.project}}
            </div>
            <div class="td">
              {{item.message}}
            </div>
          </div>
        </div>
      </div>
      <div class="content-table-box">
        <div id="tabBox1" class="content-table-box-content">
          <div class="content-table-content-cell">
            <div class="td th content-table-td">
              省份
            </div>
            <div class="td th content-table-td-1">
              城市
            </div>
          </div>
          <div
            class="content-table-content-cell"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="td content-table-td">
              {{item.province}}
            </div>
            <div class="td content-table-td-1">
              {{item.city}}
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="content-table-box"></div> -->
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from 'axios';
export default {
  name: "home",
  data() {
    return {
      Width: 0,
      list:[]
    };
  },
  created(){
  this.getData();
  },
  mounted() {
    
  },
  methods: {
    getData(){
      var _this = this;
      axios.get('./static/huisuo.json')
  .then(function (response) {
    if(response.data.status == 200){
      _this.list = response.data.result;
    }
  })
  .catch(function (error) {
    // handle error
    console.log(error);
  })
  .then(function () {
    // always executed
  });
    },
    //计算高度
    getCellHeight() {
      $("#tabBox .content-table-content-cell").each(function(i) {
        $("#tabBox1 .content-table-content-cell")
          .eq(i)
          .height($(this).height());
      });
    }
  }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.homecontent{
    width: 100%;
    background-color: #fff;
    padding: 15px 15px;
    box-sizing: border-box;
}
.content {
  width: 100%;
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  border-right: 1px solid #ddd;
}

.content-table {
  width: 100%;
  position: relative;
  overflow-x: auto;
}
.content-table-content {
  position: relative;
  min-width: 1024px;
  background-color: #fff;
  border-left: 1px solid #ddd;
}

.content-table-content-cell {
  width: 100%;
  position: relative;
  display: flex;
  border-bottom: 1px solid #ddd;
}

@media only screen and (min-width: 1025px) {
  .content-table-box {
    display: none;
    position: fixed;
    z-index: 99;
    top: 0px;
    box-sizing: border-box;
    width: 240px;
    background-color: #fff;
    bottom: 0px;
    left: 0px;
  }

  .content-table-content-cell .td {
    width: 12.5%;
    line-height: 24px;
    padding: 5px 2px;
    box-sizing: border-box;
    border-right: 1px solid #ddd;
    font-size: 16px;
    color: #000;
  }
  .th {
    border-top: 1px solid #ddd;
    font-weight: 600;
    line-height: 30px !important;
    color: #813600 !important;
  }
  .content-title {
    width: 100%;
    font-size: 24px;
    line-height: 30px;
    font-weight: 600;
    color: #000;
  }
  .content-dec{
    width: 100%;
    margin: 25px 0px;
    font-size: 16px;
    text-align: left;
    color: #000;
  }
}
@media only screen and (max-width: 1024px) {
  .content-table-box {
    position: absolute;
    z-index: 99;
    top: 0px;
    display: flex;
    flex-wrap: wrap;
    width: 180px;
    padding-left: 0px;
    box-sizing: border-box;
    background-color: #fff;
    left: 0px;
  }
  .content-table-box-content {
    width: 100%;
    position: relative;
    border-left: 1px solid #ddd;
  }
  .content-table-content {
    position: relative;
    min-width: 1024px;
    background-color: #fff;
    border-left: 1px solid #ddd;
  }
  .content-table-content-cell .td {
    line-height: 16px;
    width: 25%;
    height: 58px;
    overflow-y: auto;
    padding: 5px 2px;
    box-sizing: border-box;
    border-right: 1px solid #ddd;
    font-size: 12px;
    color: #000;
  }
 .td::-webkit-scrollbar{
    width: 0px;
    height: 0px;
  }
  .th {
    border-top: 1px solid #ddd;
    font-weight: 600;
    line-height: 30px !important;
    color: #813600 !important;
  }
  .content-table-td {
    width: 60px !important;
    min-width: 60px;
  }
  .content-table-td-1 {
    width: 120px !important;
    min-width: 120px;
  }
  .content-title {
    width: 100%;
    font-size: 20px;
    line-height: 34px;
    font-weight: 600;
    color: #000;
  }
  .content-dec{
    width: 100%;
    margin: 10px 0px;
    font-size: 14px;
    text-align: left;
    color: #000;
    line-height: 22px;
  }
}
 a{
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue